import { render, staticRenderFns } from "./Calculoid.vue?vue&type=template&id=12863842&"
import script from "./Calculoid.vue?vue&type=script&lang=js&"
export * from "./Calculoid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports